import React from "react";
import "./GoalTracker.css";

const GoalTracker = ({ gameState }) => {
  const goals = [
    {
      label: "Money",
      current: gameState.money,
      target: 1000000,
      format: (value) => `$${Math.floor(value).toLocaleString()}`,
    },
    {
      label: "Users",
      current: gameState.userCount,
      target: 100000,
      format: (value) => Math.floor(value).toLocaleString(),
    },
    {
      label: "Algorithm",
      current: gameState.maxAlgorithmLevel,
      target: 10,
      format: (value) => `Level ${value}`,
    },
  ];

  return (
    <div className="goal-tracker">
      <div className="goal-list">
        {goals.map((goal) => (
          <div key={goal.label} className="goal-item">
            <div className="goal-label">{goal.label}</div>
            <div className="goal-progress">
              <div
                className="progress-bar"
                style={{
                  width: `${Math.min(
                    100,
                    (goal.current / goal.target) * 100
                  )}%`,
                  backgroundColor:
                    goal.current >= goal.target ? "#10b981" : "#4f46e5",
                }}
              />
            </div>
            <div className="goal-values">
              <span>{goal.format(goal.current)}</span>
              <span>/ {goal.format(goal.target)}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GoalTracker;
